import { render, staticRenderFns } from "./Redio.vue?vue&type=template&id=0c6edadc"
import script from "./Redio.vue?vue&type=script&lang=js"
export * from "./Redio.vue?vue&type=script&lang=js"
import style0 from "./Redio.vue?vue&type=style&index=0&id=0c6edadc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports